import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IPersonal {
  Id: number | null | undefined;
  BarId: string | null | undefined;
  MemberTypeId: number | null | undefined;
  MemberCodeId: number | null | undefined;
  Title: string | null | undefined;
  Esquire: string | null | undefined;
  FirstName: string | null | undefined;
  LastName: string | null | undefined;
  Gender: string | null | undefined;
  DateOfBirth: string | null | undefined;
  AdmitDate: string | null | undefined;
  IsValidSupremeCourtId: number | null | undefined;
  IsMediator: Boolean | null | undefined;
  IsArbitrator: Boolean | null | undefined;
  MediatorCertificationEndsOn: string | null | undefined;
  Comments: string | null | undefined;
}
interface IAddress {
  Id: number | null;
  MemberId: number | null;
  FirmName: string | null;
  Address1: string | null;
  Address2: string | null;
  City: string | null;
  County: string | null;
  State: string | null;
  Zipcode: string | null;
  PhoneNumber: string | null;
  CellPhoneNumber: string | null;
  FaxNumber: string | null;
  Email: string | null;
  AddressType: string | null;
  FirmAdminName: string | null;
  FirmAdminPhoneNumber: string | null;
  FirmAdminEmailId: string | null;
}

interface OtherStateBar {
  BarName: string;
  AdmitDate: string;
  BarId: string;
}

interface IMember {
  Personal: IPersonal;
  PrimaryAddress: IAddress | null;
  PublishedAddress: IAddress | null;
  Address: IAddress[];
  OtherStateBar: OtherStateBar[];
}

const initialState: IMember = {
  Personal: {
    Id: null,
    BarId: null,
    MemberTypeId: null,
    MemberCodeId: null,
    Title: null,
    Esquire: null,
    FirstName: null,
    LastName: null,
    Gender: null,
    DateOfBirth: null,
    AdmitDate: null,
    IsValidSupremeCourtId: null,
    IsMediator: null,
    IsArbitrator: null,
    MediatorCertificationEndsOn: null,
    Comments : null,
  },
  PrimaryAddress: null,
  PublishedAddress: null,
  OtherStateBar: [],
  // PrimaryAddress: {
  //     Id: null,
  //     MemberId: null,
  //     FirmName: null,
  //     Address1: null,
  //     Address2: null,
  //     County: null,
  //     State: null,
  //     Zipcode: null,
  //     PhoneNumber: null,
  //     FaxNumber: null,
  //     Email: null,
  // },
  // PublishedAddress : {
  //     Id: null,
  //     MemberId: null,
  //     FirmName: null,
  //     Address1: null,
  //     Address2: null,
  //     County: null,
  //     State: null,
  //     Zipcode: null,
  //     PhoneNumber: null,
  //     FaxNumber: null,
  //     Email: null,
  // },
  Address: [
    {
      Id: null,
      MemberId: null,
      FirmName: null,
      Address1: null,
      Address2: null,
      City: null,
      County: null,
      State: null,
      Zipcode: null,
      PhoneNumber: null,
      CellPhoneNumber: null,
      FaxNumber: null,
      Email: null,
      AddressType: null,
      FirmAdminName: null,
      FirmAdminPhoneNumber: null,
      FirmAdminEmailId: null,
    },
  ],
};
type BodyType = {
  key: string;
  value: string | number[] | Boolean | null;
};
export const editMemberapiSlice = createSlice({
  name: "apiSlice",
  initialState,
  reducers: {
    assignMemberPersonal: (state: any, action: PayloadAction<IPersonal>) => {
      console.log("assigned editMemberapiSlice", action.payload);
      state.Personal = action.payload;
    },
    editMemberPersonal: (state: any, action: PayloadAction<BodyType>) => {
      const newState = { ...state };
      newState.Personal = {
        ...newState.Personal,
        [action.payload.key]: action.payload.value,
      };

      // Return the new state
      return newState;
    },
    /*
        assignMemberPrimaryAddress: (state: any, action: PayloadAction<IAddress>) => {
            state.Address[0] = action.payload;
        },
        editMemberPrimaryAddress: (state: any, action: PayloadAction<BodyType>) => {
            state.Address[0] [action.payload.key] = action.payload.value;
        },
        assignMemberPublishedAddress: (state: any, action: PayloadAction<IAddress>) => {
            state.Address[1] = action.payload;
        },
        editMemberPublishedAddress: (state: any, action: PayloadAction<BodyType>) => {
            state.Address[1][action.payload.key] = action.payload.value;
        },
        */
    assignMemberPrimaryAddress: (
      state: any,
      action: PayloadAction<IAddress>
    ) => {
      state.PrimaryAddress = action.payload;
    },
    editMemberPrimaryAddress: (state: any, action: PayloadAction<BodyType>) => {
      const newState = { ...state };
      newState.PrimaryAddress = {
        ...newState.PrimaryAddress,
        [action.payload.key]: action.payload.value,
      };

      // Return the new state
      return newState;
    },
    assignMemberPublishedAddress: (
      state: any,
      action: PayloadAction<IAddress>
    ) => {
      state.PublishedAddress = action.payload;
    },

    editMemberPublishedAddress: (
      state: any,
      action: PayloadAction<BodyType>
    ) => {
      const newState = { ...state };
      newState.PublishedAddress = {
        ...newState.PublishedAddress,
        [action.payload.key]: action.payload.value,
      };

      // Return the new state
      return newState;
    },
    resetEditMemberBody: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const {
  assignMemberPersonal,
  editMemberPersonal,
  assignMemberPrimaryAddress,
  editMemberPrimaryAddress,
  assignMemberPublishedAddress,
  editMemberPublishedAddress,
} = editMemberapiSlice.actions;

export default editMemberapiSlice.reducer;
